export default "__VITE_ASSET__VrEaBmUB__"